/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_No_Pages_AvailableInputs */

const en_mobile_no_pages_available = /** @type {(inputs: Mobile_No_Pages_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pages available`)
};

const es_mobile_no_pages_available = /** @type {(inputs: Mobile_No_Pages_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay páginas disponibles`)
};

/**
* | output |
* | --- |
* | "No pages available" |
*
* @param {Mobile_No_Pages_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_no_pages_available = /** @type {((inputs?: Mobile_No_Pages_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_No_Pages_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_no_pages_available(inputs)
	return en_mobile_no_pages_available(inputs)
});